import { MODAL_EVENTS } from '../Modal';

export default class ModalButton extends HTMLElement {
  behavior;
  clickableEl = this;
  extraData = {};
  MODAL_EVENTS = MODAL_EVENTS;
  keepClickable = false;

  constructor() {
    super();
    this.role = 'button';
    this.keepClickable = this.getAttribute('data-keep-clickable') === 'true';

    if (!this.keepClickable) {
      const hasButtonOrAnchor = this.querySelector('button, a');

      this.clickableEl = hasButtonOrAnchor || this;
    }

    this.behavior = this.getAttribute('data-behavior') || 'open';
  }

  connectedCallback() {
    this.clickableEl.addEventListener('click', this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.clickableEl.removeEventListener('click', this.handleClick);
  }

  handleClick(e) {
    const isDesktop = window.innerWidth >= 1024;

    if (this.keepClickable && isDesktop) {
      return;
    }

    e.preventDefault();

    const AVAILABLE_BEHAVIORS = ['open', 'close', 'toggle'];

    if (!AVAILABLE_BEHAVIORS.includes(this.behavior)) {
      console.warn(`Invalid behavior for modal button: "${this.behavior}". Setting behavior to "toggle."`);
      this.behavior = 'toggle';
    }

    const id = this.getAttribute('data-modal-id');

    if (!id) {
      console.error('Modal button must have a data-modal-id attribute');
      return;
    }

    document.dispatchEvent(
      new CustomEvent(MODAL_EVENTS[this.behavior], {
        bubbles: false,
        detail: { id, ...this.extraData },
      }),
    );
  }
}
